import React from "react";
import { Redirect } from "react-router-dom";
import { getHomeByLoggedInUser } from '../helpers/authUtils';


// lazy load all the views
const Dashboard = React.lazy(() => import("../pages/Dashboard/index"));
const StarterPage = React.lazy(() => import("../pages/StarterPage/index"));
const WzapAdministrator = React.lazy(() => import("../pages/WzapAdministrator/index"));
const Administrator = React.lazy(() => import("../pages/Administrator/index"));

// auth
const Login = React.lazy(() => import("../pages/Auth/Login"));
const Logout = React.lazy(() => import("../pages/Auth/Logout"));
const ForgetPassword = React.lazy(() => import("../pages/Auth/ForgetPassword"));
const Register = React.lazy(() => import("../pages/Auth/Register"));
const LockScreen = React.lazy(() => import("../pages/Auth/LockScreen"));

// Errors
const e401 = React.lazy(() => import("../pages/Errors/e401"));
const e404 = React.lazy(() => import("../pages/Errors/e404"));

// declare all routes
const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/pages-starter", component: StarterPage },
  { path: "/wzap-administrator", component: WzapAdministrator },
  { path: "/administrator", component: Administrator},
  {
    path: "/",
    exact: true,
    component: () => <Redirect to={getHomeByLoggedInUser()} />,
  },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forget-password", component: ForgetPassword },
  { path: "/register", component: Register },
  { path: "/lock-screen", component: LockScreen },
  { path: "/401", component: e401 },
  { path: "/404", component: e404 }
];

const routes = [...authProtectedRoutes, ...publicRoutes];

export { authProtectedRoutes, publicRoutes, routes };
